import { render, staticRenderFns } from "./FormProgramProgramModuleImport.vue?vue&type=template&id=4b83f405&scoped=true"
import script from "./FormProgramProgramModuleImport.vue?vue&type=script&lang=js"
export * from "./FormProgramProgramModuleImport.vue?vue&type=script&lang=js"
import style0 from "./FormProgramProgramModuleImport.vue?vue&type=style&index=0&id=4b83f405&prod&lang=scss&scoped=true"
import style1 from "./FormProgramProgramModuleImport.vue?vue&type=style&index=1&id=4b83f405&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83f405",
  null
  
)

export default component.exports